<template>
    <v-container>
        <v-layout row wrap align-center>
            <v-flex xs12 d-flex>
                <v-card class="elevation-0" color="gray">
                    <v-card-title>
                        <h1 class="fonte text-uppercase">Relatório Quero Taxi</h1>
                    </v-card-title>
                    <v-layout wrap row justify-space-between>
                        <v-flex d-flex class="elevation-0 ma-1 mt-2 mr-3 ml-3 mb-3">
                            <v-menu v-model="menuPicker" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="date" label="Data Inicial" color="teal" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="date" @input="menuPicker = false" color="teal"></v-date-picker>
                            </v-menu>
                            <v-menu v-model="menuPicker2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="date2" label="Data Final"  color="teal" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="date2" @input="menuPicker2 = false" color="teal"></v-date-picker>
                            </v-menu>
                            <v-flex>
                                <v-btn :loading="loading" color="fundo" large round @click="search">
                                <v-icon left>search</v-icon> Pesquisar
                                    <template v-slot:loader>
                                        <span class="custom-loader">
                                            <v-icon light>cached</v-icon>
                                        </span>
                                    </template>
                                </v-btn>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>

        <CTable :titulos="headers" :dados="formatFiltro" />
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import CTable from '../../CTable'

export default {
    components:{
        CTable
    },

    data() {
        return {
            date            : new Date().toISOString().substr(0, 10),
            date2           : new Date().toISOString().substr(0, 10),
            menuPicker      : false,
            menuPicker2     : false,
            loading         : false,
            headers         : [
                {
                    text: "Empresas",
                    align: "center",
                    value: "empresa",
                    sortable: false
                },
                {
                    text: "Total de telefones",
                    align: "center",
                    value: "telefones",
                    sortable: false
                },
                {
                    text: "Total de pedidos",
                    align: "center",
                    value: "pedidos",
                    sortable: false
                },
                {
                    text: "Total de criados",
                    align: "center",
                    value: "criado",
                    sortable: false
                },
                {
                    text: "Total de solicitados",
                    align: "center",
                    value: "solicitado",
                    sortable: false
                },
                {
                    text: "Total de expirados",
                    align: "center",
                    value: "expirado",
                    sortable: false
                },
                {
                    text: "Total de cancelados",
                    align: "center",
                    value: "cancelado",
                    sortable: false
                },
                {
                    text: "Total de concluidos",
                    align: "center",
                    value: "concluido",
                    sortable: false
                }
            ],
            pedidos         : []
        }
    },

    methods: {
        ...mapActions(['getFiltroQueroTaxi']),

        async search() {
            this.loading = true


            const filtros = {
                dt_ini: this.date,
                dt_fim: this.date2
            }

            const result    = await this.getFiltroQueroTaxi(filtros)
            this.pedidos    = result.pedidos
            this.loading    = false
        }
    },

    computed: {
        formatFiltro() {
            if(this.pedidos.length) {
                let empresas = [ ...new Set( this.pedidos.map( _ => _._id.empresa.id ) ) ]
                empresas = empresas.map( _ => this.pedidos.find( __ => __._id.empresa.id == _ )._id.empresa )


                let formating = empresas.map( _ => ({
                    empresa: _.dominio,
                    telefones: this.pedidos.filter( i => i._id.empresa.id == _.id ),
                    total_telefones: this.pedidos.filter( i => i._id.empresa.id == _.id ).length,
                    total_pedidos: this.pedidos.filter( i => i._id.empresa.id == _.id ).reduce( (acc, item) => acc + item.pedidos.length,0),
                    pedidos: this.pedidos.filter( i => i._id.empresa.id == _.id ).flatMap( p => p.pedidos )
                }))

                formating = formating.map( _ => ({
                    ..._,
                    status: [ ...new Set( _.pedidos ) ].map( it => ({status: it, total: _.pedidos.filter( i => i == it ).length }) )
                }))

                const makeObj = arr => {
                    let o = {}
                    for( let i of arr )o[ i.status ] = i.total
                    return o
                }

                return formating.map( f => ({
                    empresa: f.empresa,
                    pedidos: f.total_pedidos,
                    telefones: f.total_telefones,
                    ...makeObj(f.status)
                }) ) || []
            }
        }

    }
}

</script>



// WEBPACK FOOTER //
// src/components/root/QueroTaxi/Relatorios.vue